/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileSchemaIn } from './FileSchemaIn';
import {
    FileSchemaInFromJSON,
    FileSchemaInFromJSONTyped,
    FileSchemaInToJSON,
} from './FileSchemaIn';

/**
 * 
 * @export
 * @interface DoctorSignupStep2
 */
export interface DoctorSignupStep2 {
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof DoctorSignupStep2
     */
    medicalLicenseFront?: FileSchemaIn;
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof DoctorSignupStep2
     */
    medicalLicenseBack?: FileSchemaIn;
}

/**
 * Check if a given object implements the DoctorSignupStep2 interface.
 */
export function instanceOfDoctorSignupStep2(value: object): boolean {
    return true;
}

export function DoctorSignupStep2FromJSON(json: any): DoctorSignupStep2 {
    return DoctorSignupStep2FromJSONTyped(json, false);
}

export function DoctorSignupStep2FromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorSignupStep2 {
    if (json == null) {
        return json;
    }
    return {
        
        'medicalLicenseFront': json['medical_license_front'] == null ? undefined : FileSchemaInFromJSON(json['medical_license_front']),
        'medicalLicenseBack': json['medical_license_back'] == null ? undefined : FileSchemaInFromJSON(json['medical_license_back']),
    };
}

export function DoctorSignupStep2ToJSON(value?: DoctorSignupStep2 | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'medical_license_front': FileSchemaInToJSON(value['medicalLicenseFront']),
        'medical_license_back': FileSchemaInToJSON(value['medicalLicenseBack']),
    };
}

